const initialState = {
  dashboardDataLoading: false,
  dashboardDataSuccess: false,
  dashboardDataError: "",
  dashboardData: {},
};

export default initialState;
